export default __webpack_public_path__ + "static/media/gallery_01.ad2388a9.jpg";